<template>
  <MainLayout>
    <template #content>
      <div v-if="!IS_LOADING.status" class="content-container flex flex-col w-full px-8">
        <Header1
          label="Expired Vouchers"
        />
        <div class="flex flex-col w-full p-2">
          <Table
            class="mt-3 mx-2"
            :fields="fields"
            :data="EXPIRED_VOUCHERS"
          >
            <template #customActions="props">
              <div class="flex flex-col">
                <a
                  class="text-xs text-indigo-500 underline text-center"
                  href="javascript:void(0)"
                >
                  Update Expiration
                </a>
              </div>
            </template>
          </Table>
        </div>
      </div>
    </template>
  </MainLayout>
</template>
<script>
  import MainLayout from '_layouts';
  import Header1 from '_components/Headers/Header1';
  import Table from '_components/Table';
  import { setToken } from '_helpers/ApiService'

  export default {
    components: {
      MainLayout,
      Header1,
      Table,
    },
    data() {
      return {
        tableIndex: 0,
        fields: [
          {
            name: 'title',
            title: 'Voucher Name',
            dataClass: 'text-center',
          }, {
            name: 'actions',
            title: 'Actions',
          }
        ],
      };
    },
    computed: {
      AUTH_USER() {
        return this.$store.getters.AUTH_USER;
      },
      EXPIRED_VOUCHERS(){
        return [];
      },
      IS_LOADING()
      {
        return this.$store.getters.IS_LOADING
      },
    },
    watch: {
    },
    mounted() {
      (async() => {
        try {
          await this.$store.commit('SET_IS_LOADING', { status: 'open' })
          await this.onFetchExpiredVouchers()
          await this.$store.commit('SET_IS_LOADING', { status: 'close' })
        } catch (err) {
          await this.$store.commit('SET_IS_LOADING', { status: 'close' })
        }
      })()
    },
    methods: {
      async onFetchExpiredVouchers()
      {
        try {
          const { data } = []
        } catch (err) {
          console.log('err', err)
        }
      },
    }
  }
</script>
<style lang='css' scoped>
  .btn-switch {
    margin: 0 auto;
  }
  .btn-switch .btn {
    padding: 5px 10px;
    width: 100%;
    border: 1px solid #1a202c;
    text-align: center;
  }
  .btn-switch .btn.active {
    background-color: #1a202c;
    color: #fff;
  }
  .btn-switch .btn.btn-left {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }
  .btn-switch .btn.btn-right {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }
</style>